export default __webpack_public_path__ + "static/media/sticker-M.1c300089.png";